export default "__VITE_ASSET__55425c30__"